export type AccountNameSource = {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  username?: string | null;
};

export function accountName(account: AccountNameSource): string {
  const fullName = [account.firstName, account.lastName]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ");
  if (fullName) return fullName;

  return String(account.username || account.name || "").trim() || "-";
}
